import { GalleryColorLabel } from '@nusign/picflow-backend-types';

export const defaultColorLabels: GalleryColorLabel[] = [
  {
    color: 'red',
    name: 'Red',
    active: true,
  },
  {
    color: 'orange',
    name: 'Orange',
    active: true,
  },
  {
    color: 'blue',
    name: 'Blue',
    active: true,
  },
  {
    color: 'purple',
    name: 'Purple',
    active: true,
  },
  {
    color: 'green',
    name: 'Green',
    active: true,
  },
];
